/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_User_Email_LockedInputs */

const en_error_user_email_locked = /** @type {(inputs: Error_User_Email_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email cannot change after the first sign-in.`)
};

/**
* | output |
* | --- |
* | "The email cannot change after the first sign-in." |
*
* @param {Error_User_Email_LockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_user_email_locked = /** @type {((inputs?: Error_User_Email_LockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_User_Email_LockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_user_email_locked(inputs)
});